import * as React from 'react';
import classNames from 'classnames';
import './selectableCard.module.scss';

type Props = {
    id?: string;
    current: boolean;
    currentLabel?: string;
    selected: boolean;
    children: any;
    footer: any;
    onClick: () => any;
};

export const SelectableCard = ({ id, current, currentLabel, selected, onClick, footer, children }: Props) => {
    return (
        <div
            id={id}
            styleName={classNames('item', { current: current, selected: selected })}
            onClick={selected || current ? undefined : onClick}
        >
            <div styleName="item-main">
                {current && <div styleName="current-label">{currentLabel}</div>}
                {!current && (
                    <div styleName="check-box-wrapper">
                        <div styleName={classNames('check-box', { selected: selected })}>
                            {selected && <div styleName="check-box-inner" />}
                        </div>
                    </div>
                )}
                <div styleName="item-body">{children}</div>
            </div>
            {footer && <div styleName="item-footer">{footer}</div>}
        </div>
    );
};
